import React from 'react';
import PropTypes from 'prop-types';

const WorkspaceCard = ({ children }) => (
  <div className="grid workspace-card">{children}</div>
);

WorkspaceCard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WorkspaceCard;
